import Ajv from 'ajv';
import i18next from 'i18next';
import parse from 'html-react-parser';

import PropsEditorModal from '@backoffice/components/PropsEditorModal';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

const ajv = new Ajv();

const DEFAULT_CREDENTIALS = {
  email: '',
  clientId: '',
  clientSecret: '',
};

const schema = {
  type: 'object',
  properties: {
    clientId: { type: 'string', minLength: 1 },
    clientSecret: { type: 'string', minLength: 1 },
    email: { type: 'string', format: 'email' },
  },
  required: ['clientId', 'clientSecret', 'email'],
  additionalProperties: false,
};

export const getPropsEditorModalConfig = ({ credentials, props, onPropsChange, handleSave }) => {
  const validate = ajv.compile(schema);

  const valid = validate(props);

  return {
    type: 'action',
    width: '600px',
    height: 'auto',
    icon: '/images/inpulse/gear-black-small.svg',
    title: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_STEF_ORDER_AVAILABILITY_CONFIGURATION_TITLE'),
    component: PropsEditorModal,
    data: {
      json: props,
      schema: schema,
      onChange: (value) => onPropsChange(credentials, value),
      description: parse(
        i18next.t(
          'ADMIN.SUPPLIERS.SUPPLIER_DETAIL_STEF_ORDER_AVAILABILITY_CONFIGURATION_DESCRIPTION',
        ),
      ),
    },
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_SAVE_BUTTON(),
        key: 1,
        isDisabled: !valid,
        handleClick: () => handleSave(credentials),
      },
    ],
  };
};

export default { getPropsEditorModalConfig, DEFAULT_CREDENTIALS };
